import React from "react"
import { SortIcon } from "components/Table_SortColumnIcon"

const clientsListColumns = () => {
  return [
    {
      text: "Company",
      dataField: "name",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, client) => <>{client.name}</>,
    },
    {
      text: "ID",
      dataField: "id",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, client) => <>{client.id}</>,
    },
    {
      text: "Name",
      dataField: "contact_name",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, client) => <>{client.contact_name}</>,
    },
    {
      text: "Email",
      dataField: "email",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, client) => <>{client.email}</>,
    },
    {
      text: `p8 iOS`,
      headerFormatter: column => (
        <>
          {column.text} {"  "}
          <i className="bx bxs-bell" />
        </>
      ),
      dataField: "p8_certificate_name",
      formatter: (cellContent, client) =>
        client?.p8_certificate_name &&
        client?.bundle_id &&
        client?.key_id &&
        client?.team_id ? (
          <i className="bx bx-sm bx-check"></i>
        ) : (
          <i className="bx bx-sm bx-x"></i>
        ),
    },
  ]
}

export default clientsListColumns
